<template>
  <div>
    <OwnersForm
      :selected-owner="user"
      :business-corp-country="business.corpCountry"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import stateModuleAware from '@/mixins/state-module-aware';
import OwnersForm from '@/components/forms/OwnersForm.vue';

export default {
  components: {
    OwnersForm,
  },
  mixins: [stateModuleAware],
  computed: {
    ...mapGetters(['business', 'user']),
  },
};
</script>
